import TopSellingSection from "./homeSections/topSellingSection/topSellingSection";
import Footer from "./homeSections/footer/footer";
import NewArrivalsSection from "./homeSections/newArrivalsSection/newArrivalsSection";
import HeroSection from "./homeSections/heroSection/heroSection";
import ViewByTypeSection from "./homeSections/viewByType/ViewByType";
import { Helmet } from "react-helmet";


export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>Worldwide Shipping Online Shopping for Clothes | SHOP.CO</title>
        <meta
          name="description"
          content="Discover the best worldwide shipping online shopping experience. Shop trendy clothes from 200+ brands with fast delivery & top quality."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/"
        />
      </Helmet>

      <HeroSection />
      <NewArrivalsSection />
      <TopSellingSection />
      <ViewByTypeSection />
      <Footer />
    </>
  )
}